/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { GridBox, Element } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { isPhone } from '@helpers';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const horizontalLine = isPhone ? 4 : 5;
const verticalsLine = 4;

const Content = (props) => {
  const { combineVertical, combineHorizontal, vertical, horizontal, scaleFactor, scale, width, height, C } = props;
  const color = 'rgba(255, 0, 0, 0.1)';

  const CenterElement = () => {
    return (
      <View>
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 28,
              height: 28,
              parentWidth: scale(72),
              parentHeight: scale(72),
              border: {
                borderStyle: 'dashed',
                borderWidth: StyleSheet.hairlineWidth,
                borderRadius: scale(3),
                boderColor: '#D2D2D2',
              },
            },
          }}
        />
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 12,
              height: 2,
              parentWidth: scale(72),
              parentHeight: scale(72),
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 2,
              height: 12,
              parentWidth: scale(72),
              parentHeight: scale(72),
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
      </View>
    );
  };
  const LineElement = ({ bg, pos }) => {
    const position = (() => {
      switch (pos) {
        case 'top':
          return { position: { top: 5 }, horizontalCenter: 0 };
        case 'left':
          return { position: { left: 5 }, verticalCenter: 0 };
        case 'bottom':
          return { position: { bottom: 5 }, horizontalCenter: 0 };
        case 'right':
          return { position: { right: 5 }, verticalCenter: 0 };
      }
    })();

    const size = (() => {
      switch (pos) {
        case 'top':
          return { width: 2, height: 12 };
        case 'left':
          return { width: 12, height: 2 };
        case 'bottom':
          return { width: 2, height: 12 };
        case 'right':
          return { width: 12, height: 2 };
      }
    })();

    return (
      <Element
        {...{
          config: {
            ...position,
            ...size,
            parentWidth: scale(72),
            parentHeight: scale(72),
            backgroundColor: bg,
          },
        }}
      />
    );
  };
  return (
    <View
      style={{
        flex: 1,
        width: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Element
        {...{
          config: {
            position: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            },
          },
        }}
      >
        <View
          style={{
            width: '100%',
            height: '100%',
            justifyContent: 'space-between',
          }}
        >
          {Array.from({ length: horizontalLine }).map((item, index) => (
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                height: horizontal,
                width: '100%',
              }}
              key={`line-${index}`}
            >
              {Array.from({ length: verticalsLine }).map((it, i) => (
                <View
                  key={`block-${i}`}
                  style={{
                    width: vertical,
                    height: horizontal,
                    opacity: 0.5,
                  }}
                />
              ))}
            </View>
          ))}
        </View>
      </Element>
      <View
        style={{
          height: combineHorizontal(2),
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            width: vertical,
            backgroundColor: color,
          }}
        />
        <View
          style={{
            width: combineVertical(2),
            backgroundColor: color,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View
            style={{
              width: scale(72),
              height: scale(72),
              borderRadius: scale(3.4),
              border: {
                borderRadius: scale(3.4),
                borderWidth: StyleSheet.hairlineWidth,
                borderColor: '#D2D2D2',
              },
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
            }}
          >
            <LineElement {...{ bg: '#8E8E93', pos: 'top' }} />
            <LineElement {...{ bg: '#8E8E93', pos: 'left' }} />
            <LineElement {...{ bg: '#8E8E93', pos: 'bottom' }} />
            <LineElement {...{ bg: '#8E8E93', pos: 'right' }} />
            <CenterElement />
          </View>
        </View>
        <View
          style={{
            width: vertical,
            backgroundColor: color,
          }}
        />
      </View>
      <View
        style={{
          height: combineHorizontal(isPhone ? 2 : 3),
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            width: vertical,
            backgroundColor: color,
          }}
        />
        <View
          style={{
            width: vertical,
          }}
        >
          <Element
            {...{
              config: {
                position: {
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                },
                backgroundColor: 'rgba(118, 118, 128, 0.14)',
                borderRadius: scale(SCREEN_BORDER_RADIUS),
              },
            }}
          >
            <Element
              {...{
                config: {
                  position: {
                    top: 0,
                    left: 0,
                    right: 0,
                  },
                  height: 60,
                  backgroundColor: 'rgba(0, 0, 0, 0.2)',
                  borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
                  borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                  justifyContent: 'center',
                  alignContent: 'center',
                },
              }}
            >
              <Text
                style={{
                  color: '#FFFFFF',
                  fontSize: scale(16),
                  textAlign: 'center',
                }}
              >
                Header
              </Text>
              <Text
                style={{
                  color: '#FFFFFF',
                  fontSize: scale(16),
                  textAlign: 'center',
                }}
              >
                with fixed heigth
              </Text>
            </Element>
            <Element
              {...{
                config: {
                  width: vertical,
                  verticalCenter: 1.5,
                  parentHeight: combineHorizontal(isPhone ? 2 : 3),
                  horizontalCenter: 0.5,
                  parentWidth: vertical,
                },
              }}
            >
              <Text
                style={{
                  color: '#000000',
                  fontSize: scale(15),
                  textAlign: 'center',
                  width: vertical,
                }}
              >
                Tile on layout grid column
              </Text>
            </Element>
          </Element>
        </View>
        <View
          style={{
            width: vertical,
            backgroundColor: color,
          }}
        />
        <View
          style={{
            width: vertical,
            backgroundColor: color,
          }}
        />
      </View>
    </View>
  );
};

const WrappContent = (props) => {
  const { C } = props;
  return [
    <GridBox
      {...{
        horizontalLine: horizontalLine,
        verticalsLine: verticalsLine,
        horizontalSpace: isPhone ? 72 : 2,
        verticalSpace: isPhone ? 12 : 8,
        horizontalEdgeBottom: isPhone ? 72 : 16,
        horizontalEdgeTop: isPhone ? 72 : 16,
        verticalEdge: 18,
        backgroundColor: C('Background / Light / Detail [mobile]'),
        headerOffset: false,
      }}
    >
      <Content {...props} />
    </GridBox>,
  ];
};

export default ColorWrapper(WrappContent);
